export const Store = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <g mask='url(#mask0_1110_2637)'>
        <path
          d='M17.616 4.90347C17.166 3.82361 16.1188 3.125 14.9486 3.125H5.05139C3.88125 3.125 2.83403 3.82292 2.38403 4.90347L1.25 7.625V8.66528C1.25 9.60972 1.92153 10.4007 2.8125 10.5847V17.5H17.1875V10.5847C18.0785 10.4007 18.75 9.60972 18.75 8.66528V7.625L17.616 4.90347ZM15.8854 5.62431L16.875 8V8.66528C16.875 8.71181 16.8368 8.75 16.7903 8.75H15.625L14.2625 5H14.9493C15.3604 5 15.7278 5.24514 15.8854 5.62431ZM9.0625 8.75H6.57708L7.79306 5H9.06319V8.75H9.0625ZM10.9375 5H12.2667L13.6292 8.75H10.9368V5H10.9375ZM3.20972 8.75C3.16319 8.75 3.125 8.71181 3.125 8.66528V8L4.11458 5.62431C4.27292 5.24514 4.64028 5 5.05069 5H5.82083L4.60486 8.75H3.20903H3.20972ZM15.3125 15.625H4.6875V10.625H15.3125V15.625Z'
          fill='#695F5F'
        />
      </g>
    </svg>
  );
};
